export enum AiChatChristmasBulbColor {
  WARM = 'WARM',
  RED = 'RED',
  BLUE = 'BLUE',
}

export interface AiChatChristmasBulb {
  leftPercent: number;
  topPercent: number;
  color: AiChatChristmasBulbColor;
  twinkleSeconds: number;
  twinkleOffsetSeconds: number;
}

export interface AiChatChristmasTreeSnowDot {
  leftPercent: number;
  topPercent: number;
  sizePx: number;
  driftPx: number;
  fallPx: number;
  fallSeconds: number;
  delayMs: number;
}

export const STAR_SPARK_ANGLES_DEG = [0, 45, 90, 135, 180, 225, 270, 315];

export const AI_CHAT_CHRISTMAS_TREE_BULBS: AiChatChristmasBulb[] = [
  {leftPercent: 43.8, topPercent: 25.4, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.4, twinkleOffsetSeconds: 0},
  {leftPercent: 59.1, topPercent: 25.8, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.75, twinkleOffsetSeconds: 0.37},
  {leftPercent: 64.5, topPercent: 33.7, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 2.1, twinkleOffsetSeconds: 0.74},
  {leftPercent: 35.5, topPercent: 35.8, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 2.45, twinkleOffsetSeconds: 1.11},
  {leftPercent: 55.9, topPercent: 35.8, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 1.4, twinkleOffsetSeconds: 1.48},
  {leftPercent: 45.7, topPercent: 36.6, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.75, twinkleOffsetSeconds: 1.85},
  {leftPercent: 65.5, topPercent: 45.0, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 2.1, twinkleOffsetSeconds: 2.22},
  {leftPercent: 42.6, topPercent: 45.5, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 2.45, twinkleOffsetSeconds: 2.59},
  {leftPercent: 54.5, topPercent: 45.8, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.4, twinkleOffsetSeconds: 2.96},
  {leftPercent: 35.3, topPercent: 48.9, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.75, twinkleOffsetSeconds: 3.33},
  {leftPercent: 46.8, topPercent: 56.1, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 2.1, twinkleOffsetSeconds: 3.7},
  {leftPercent: 55.5, topPercent: 59.2, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 2.45, twinkleOffsetSeconds: 4.07},
  {leftPercent: 68.5, topPercent: 63.0, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.4, twinkleOffsetSeconds: 4.44},
  {leftPercent: 58.5, topPercent: 64.2, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 1.75, twinkleOffsetSeconds: 4.81},
  {leftPercent: 30.3, topPercent: 64.6, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 2.1, twinkleOffsetSeconds: 5.18},
  {leftPercent: 77.9, topPercent: 64.6, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 2.45, twinkleOffsetSeconds: 5.55},
  {leftPercent: 44.5, topPercent: 64.9, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.4, twinkleOffsetSeconds: 5.92},
  {leftPercent: 82.0, topPercent: 79.2, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 1.75, twinkleOffsetSeconds: 6.29},
  {leftPercent: 15.4, topPercent: 79.7, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 2.1, twinkleOffsetSeconds: 6.66},
  {leftPercent: 26.7, topPercent: 82.4, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 2.45, twinkleOffsetSeconds: 7.03},
  {leftPercent: 68.1, topPercent: 82.6, color: AiChatChristmasBulbColor.RED, twinkleSeconds: 1.4, twinkleOffsetSeconds: 7.4},
  {leftPercent: 58.3, topPercent: 83.4, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 1.75, twinkleOffsetSeconds: 7.77},
  {leftPercent: 38.4, topPercent: 83.7, color: AiChatChristmasBulbColor.BLUE, twinkleSeconds: 2.1, twinkleOffsetSeconds: 8.14},
  {leftPercent: 48.6, topPercent: 83.8, color: AiChatChristmasBulbColor.WARM, twinkleSeconds: 2.45, twinkleOffsetSeconds: 8.51},
];

export const AI_CHAT_CHRISTMAS_TREE_SNOW: AiChatChristmasTreeSnowDot[] = [
  {leftPercent: 48, topPercent: 18, sizePx: 2.5, driftPx: -12, fallPx: 36, fallSeconds: 1.2, delayMs: 0},
  {leftPercent: 40, topPercent: 28, sizePx: 3.25, driftPx: 19, fallPx: 48, fallSeconds: 1.4, delayMs: 70},
  {leftPercent: 58, topPercent: 30, sizePx: 4, driftPx: -26, fallPx: 60, fallSeconds: 1.6, delayMs: 140},
  {leftPercent: 33, topPercent: 40, sizePx: 2.5, driftPx: 33, fallPx: 72, fallSeconds: 1.2, delayMs: 210},
  {leftPercent: 62, topPercent: 42, sizePx: 3.25, driftPx: -12, fallPx: 36, fallSeconds: 1.4, delayMs: 280},
  {leftPercent: 50, topPercent: 38, sizePx: 4, driftPx: 19, fallPx: 48, fallSeconds: 1.6, delayMs: 0},
  {leftPercent: 27, topPercent: 52, sizePx: 2.5, driftPx: -26, fallPx: 60, fallSeconds: 1.2, delayMs: 70},
  {leftPercent: 70, topPercent: 54, sizePx: 3.25, driftPx: 33, fallPx: 72, fallSeconds: 1.4, delayMs: 140},
  {leftPercent: 45, topPercent: 50, sizePx: 4, driftPx: -12, fallPx: 36, fallSeconds: 1.6, delayMs: 210},
  {leftPercent: 22, topPercent: 64, sizePx: 2.5, driftPx: 19, fallPx: 48, fallSeconds: 1.2, delayMs: 280},
  {leftPercent: 78, topPercent: 66, sizePx: 3.25, driftPx: -26, fallPx: 60, fallSeconds: 1.4, delayMs: 0},
  {leftPercent: 55, topPercent: 62, sizePx: 4, driftPx: 33, fallPx: 72, fallSeconds: 1.6, delayMs: 70},
  {leftPercent: 18, topPercent: 76, sizePx: 2.5, driftPx: -12, fallPx: 36, fallSeconds: 1.2, delayMs: 140},
  {leftPercent: 84, topPercent: 78, sizePx: 3.25, driftPx: 19, fallPx: 48, fallSeconds: 1.4, delayMs: 210},
  {leftPercent: 40, topPercent: 74, sizePx: 4, driftPx: -26, fallPx: 60, fallSeconds: 1.6, delayMs: 280},
  {leftPercent: 63, topPercent: 76, sizePx: 2.5, driftPx: 33, fallPx: 72, fallSeconds: 1.2, delayMs: 0},
];
